import React from 'react';
import TabButton, { TabButtonProps } from '../TabButton/TabButton';
import { TabSelectorContainer } from './TabSelector.styles';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import Input from 'src/app/atoms/Input/Input';
import Grid from 'src/app/atoms/Layout/Grid/Grid';

export interface TabSelectorProps {
  tabs: TabButtonProps[];
  selectPlaceholder?: string;
}

const TabSelector = ({ tabs, selectPlaceholder }: TabSelectorProps): JSX.Element => {
  const selectedTab = tabs.find((tab) => tab.isSelected);

  const handleTabSelect = (tabLabel: string) => {
    const tab = tabs.find((tab) => tab.label === tabLabel);

    tab?.onClick(tabLabel);
  };

  return (
    <>
      <TabSelectorContainer
        padding='spacing-sm'
        gap='spacing-xl'
        direction='row'
        hideOn='sm'
        justify='center'
        align='center'
        background='bg-secondary-alt'
        borderRadius='radius-xl'
        border='1px solid var(--border-secondary)'
      >
        {tabs.map((tab) => (
          <TabButton
            key={tab.label}
            {...tab}
          />
        ))}
      </TabSelectorContainer>
      <Grid
        showOn='sm'
        maxWidth='width-sm'
        padding={['spacing-none', 'spacing-xl']}
      >
        <Stack>
          <Input
            type='select'
            value={selectedTab?.label ?? ''}
            onChange={handleTabSelect}
            placeholder={selectPlaceholder}
            options={tabs.map((tab) => ({
              label: tab.label,
              value: tab.label,
            }))}
          />
        </Stack>
      </Grid>
    </>
  );
};

export default TabSelector;
